var render = function render(){var _vm=this,_c=_vm._self._c;return _c('signal-indicator',{attrs:{"strength":_vm.position.$categoricalSignalStrength},on:{"strength-change":function($event){return _vm.$emit('strength-change', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }